<template>
  <div class="header-nav head_background" @mousewheel.prevent>
	<div class="navleftlogo" @click="hometo">
		<img :src="logo_src" alt="Woodpecker" />
	</div>
	<div class="nav-hover-zone" @mouseleave="navcenter_leave">
	  <div class="nav-center" style="color: rgba(0,0,0,.6);">
		  <section class="nav-center-item"
				   v-for="(item,index) in header_list"
				   :key="index"
				   :style="nav_index == index ?'color:'+$store.state.themeColor:''"
				   :class="nav_text_color+'hover'"
		  >
			  <span @mouseenter="head_nav_mouseenter(index)"
					@click="nav_title_click(index)"
					style="cursor: pointer"
			  >
				  {{header_list[index].name}}
			  </span>
		  </section>
	  </div>
		  <section class="head_kid_bg_shadow"></section>
		  <section class="head_kid_bg" :style="nav_index!==2?'align-items:center':''" ref="head_kid_bg">
			  <div v-if="nav_index == 4"><!-- 关于我们 -->
				  <div class="nav_text_tag" @click.stop="aboutto(1)" :key="1">
					  <span :style="nav_title_index1==1?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index1=1">{{about}}</span>
				  </div>
				  <div class="nav_text_tag" @click.stop="aboutto(2)" :key="2">
					  <span :style="nav_title_index1==2?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index1=2">{{around}}</span>
				  </div>
				  <div class="nav_text_tag" @click.stop="aboutto(3)" :key="3">
					  <span :style="nav_title_index1==3?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index1=3">{{honor}}</span>
				  </div>
<!--				  <div class="nav_text_tag" @click.stop="aboutto(4)" :key="4">-->
<!--					  <span :style="nav_title_index1==4?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index1=4">{{news}}</span>-->
<!--				  </div>-->
			  </div>
			  <!-- 产品中心 -->
			  <div v-else-if="nav_index == 1" class="prodcut_center" ref="prodcut_center">
				  <!-- 第一级小标题列表 -->
				  <div v-if="navRow > 2">
					  <div class="hoverxia" v-if="nav_title_index > 1" style="margin-top: -8px">
						  <img src="../assets/pchomeimg/xiala1.svg" :style="{transform:'scale(1,-1)'}" @click="pronavnumser('prve')" />
						  <img src="../assets/pchomeimg/xiala1.svg" :style="{transform:'scale(1,1)'}" @click="pronavnumser('next')" />
					  </div>
					  <div class="hoverxia" v-else>
						  <img src="../assets/pchomeimg/xiala1.svg" :style="{transform:'scale(1,1)'}" @click="pronavnumser('next')" />
					  </div>
				  </div>
				  <div v-else>
					  <div class="hoverxia">
						  <img src="../assets/pchomeimg/xiala1.svg" :style="{transform:'scale(1,-1)'}" @click="pronavnumser('prve')" v-if="nav_list_bool"/>
						  <img src="../assets/pchomeimg/xiala1.svg" :style="{transform:'scale(1,1)'}" @click="pronavnumser('next')" v-else/>
					  </div>
				  </div>

				  <div class="prodcut_center_nav" ref="prodcut_center_nav">


<!--					  <span class="prodcut_center_little_title"-->
<!--							v-for="(item,index) in categorylist"-->
<!--							@mouseenter="getProductCateList(item.id,index)"-->
<!--							:class="nav_text_color+'_hover'"-->
<!--							:style="hovheaitind==item.id?'color:'+$store.state.themeColor:''">-->
<!--								{{item.name}}-->
<!--							</span>-->
					  <div class="prodcut_center_nav_box" ref="prodcut_center_nav_box">
						  <span class="prodcut_center_little_title"
								v-for="(item,index) in categorylist"
								ref="prodcut_center_little_title"
								style="display: flex;justify-content: center;align-items: center;"
						  >
						  	<span
									@mouseenter="getProductCateList(item.id,index)"
									:class="nav_text_color+'_hover'"
									:style="hovheaitind==item.id?'color:'+$store.state.themeColor:' '"
									style="cursor: pointer;"
							>
								{{item.name}}
							</span>
						</span>
					  </div>
					  <!-- @mouseleave="getProductCateList(nav_product_check)" -->
					  <!-- @click="nav_product_title_click(item.id)" -->
				  </div>
				  <!-- 第一级小标题列表旁的点击更多按钮 -->
				  <!-- 二级内容 -->
				  <!-- :style="list_img?'justify-content:none':'justify-content:center'" -->
				  <div class="product_center_contant">
					  <div class="product_center_contant_item"
						   ref="product_center_contant_item"
						   v-for="(item, index) in list_img"
						   :key="index"
						   :class="show_product ? 'product_center_contant_item_animate' : ''"
						   :style="'animation-delay:'+(tanimationDelay+(index/10))+'s'"
					  >
              <div class="shadow b-radius pb-20">
                <div class="product_center_contant_item_img" @click="toProduct(item.id)">
                  <img :src="item.menu_image" />
                </div>
                {{item.name}}
              </div>
					  </div>
					  <!-- <div class="product_center_contant_item"
                       v-for="(item, index) in list_img" >
                       <router-link :to="{path:'/pcdetails',query:{e:item.id}}" style="text-decoration:none">
                           <div class="product_center_contant_item_img">
                              <img :src="item.menu_image" />
                          </div>
                          <div style="color:#5d5f5f;">
                              {{item.name}}
                          </div>
                       </router-link>
                      </div> -->
				  </div>
				  <div class="inhover-icon">
					  <div class="netx" @click="nextimg()" @mouseenter="playenterli()" @mouseleave="playleaveli()">
						  <img v-if="playli" src="../assets/pchomeimg/play.svg" />
						  <img v-if="!playli" :src="$store.state.arrowIcon" />
					  </div>
					  <div class="hovecentbut" @click="productto">
						  {{heanavall}}
						  <img src="../assets/pchomeimg/morntoproimg.svg" />
					  </div>
					  <div class="pre" @click="preimg" @mouseenter="playenterri()"  @mouseleave="playleaveri()">
						  <img v-if="playri" src="../assets/pchomeimg/play.svg" style="transform:scale(-1,1)"/>
						  <img v-if="!playri" :src="$store.state.arrowIcon" style="transform:scale(-1,1)"/>
					  </div>
				  </div>
			  </div>
			  <!-- 视频中心 -->
<!--			  <div  v-else-if="nav_index == 2">-->
<!--				  <div class="nav_text_tag" @click.stop="videoto(0)":key="5">-->
<!--					  <span :style="nav_title_index3==1?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index3=1">{{vidtitleo}}</span>-->
<!--				  </div>-->
<!--				  <div class="nav_text_tag" @click.stop="videoto(1)" :key="6">-->
<!--					  <span :style="nav_title_index3==2?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index3=2">{{vidtitlet}}</span>-->
<!--				  </div>-->
<!--				  <div class="nav_text_tag" @click.stop="videoto(2)" :key="7">-->
<!--					  <span :style="nav_title_index3==3?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index3=3">{{vidtitlew}}</span>-->
<!--				  </div>-->
<!--			  </div>-->

			  <!-- 教育 -->
<!--			  <div  v-else-if="nav_index == 2">-->
<!--				  <div class="nav_text_tag" @click.stop="toCourses":key="5">-->
<!--					  <span :style="nav_title_index3==1?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index3=1">{{courses}}</span>-->
<!--				  </div>-->
<!--				  <div class="nav_text_tag" @click.stop="toNewVideo" :key="6">-->
<!--					  <span :style="nav_title_index3==2?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index3=2">{{videos}}</span>-->
<!--				  </div>-->
<!--			  </div>-->

			  <!-- 用户服务 -->
			  <div  v-else-if="nav_index == 2">
				  <div class="nav_text_tag" @click.stop="queryto(1)" :key="8">
					  <span :style="nav_title_index4==1?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index4=1">{{anticoniden}}</span>
				  </div>

<!--				  <div class="nav_text_tag" @click.stop="queryto(2)" :key="10">-->
<!--					  <span :style="nav_title_index4==3?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index4=3">{{maintenance}}</span>-->
<!--				  </div>-->
<!--				  <div class="nav_text_tag" @click.stop="queryto(3)" :key="9">-->
<!--					  <span :style="nav_title_index4==2?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index4=2">{{dadownlo}}</span>-->
<!--				  </div>-->
          <div class="nav_text_tag" @click.stop="queryto(3)" :key="9">
            <span :style="nav_title_index4==2?'color:'+$store.state.themeColor:''"
                  @mouseenter="nav_title_index4=2">Specific Comparison</span>
          </div>
          <div class="nav_text_tag" @click.stop="queryto(4)" :key="11">
            <!--            <span :style="nav_title_index4==4?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index4=4">{{ comprob }}</span>-->
            <span :style="nav_title_index4==4?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index4=4">Download</span>
          </div>
<!--				  <div class="nav_text_tag" @click.stop="queryto(3)" :key="11">-->
<!--					  <span :style="nav_title_index4==4?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index4=4">{{comprob}}</span>-->
<!--				  </div>-->
			  </div>
			  <!-- 诚聘精英 -->
			  <div  v-else-if="nav_index == 8">
				  <div class="nav_text_tag" @click.stop="elitesto(1)" :key="12">
					  <span :style="nav_title_index5==1?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index5=1">{{all}}</span>
				  </div>
				  <div class="nav_text_tag" @click.stop="elitesto(2)" :key="13">
					  <span :style="nav_title_index5==2?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index5=2">{{society}}</span>
				  </div>
				  <div class="nav_text_tag" @click.stop="elitesto(3)" :key="14">
					  <span :style="nav_title_index5==3?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index5=3">{{campus}}</span>
				  </div>
			  </div>
			  <!-- 诚聘精英 -->
			  <div  v-else-if="nav_index == 7">
				  <div class="nav_text_tag" @click.stop="contactusto(1)" :key="15">
					  <span :style="nav_title_index6==1?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index6=1">{{heamap}}</span>
				  </div>
				  <div class="nav_text_tag" @click.stop="contactusto(2)" :key="16">
					  <span :style="nav_title_index6==2?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index6=2">{{message}}</span>
				  </div>
				  <div class="nav_text_tag" @click.stop="contactusto(3)" :key="17">
					  <span :style="nav_title_index6==3?'color:'+$store.state.themeColor:''" @mouseenter="nav_title_index6=3">{{recruit}}</span>
				  </div>
			  </div>
		  </section>
	</div>
	<div class="nav-right">
      <div class="search" @click="seachto()">
        <img src="../assets/pchomeimg/sousuo1.svg" />
      </div>
<!--      <div class="fffhomename" >-->
<!--        &lt;!&ndash; 啄木鸟官网-->
<!--				<img src="../assets/pchomeimg/xiala1.png" /> &ndash;&gt;-->
<!--        <el-select v-model="value" placeholder="请选择" >-->
<!--          <el-option-->
<!--            v-for="item in channel_list"-->
<!--            :key="item.id"-->
<!--            :label="item.name"-->
<!--            :value="item.id"-->
<!--			:style="heaproinde == item.id ? 'color:'+$store.state.themeColor : ''"-->
<!--          >-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </div>-->
      <div class="ffflanguage" >
        <el-select v-model="valuelang" placeholder="请选择" @change="changeLang">
          <el-option
            v-for="item in optionslang"
            :key="item.valuelang"
            :label="item.labellang"
            :value="item.valuelang"
			:style="valuelang == item.valuelang ? 'color:'+ $store.state.themeColor : ''"
          >
          </el-option>
        </el-select>
      </div>
    </div>
	<div class="header_mask" @mousewheel.prevent v-if="show_mask"></div>
  </div>
</template>

<script>
import 'lib-flexible/flexible.js'
import { session } from "./../storage/storage.js";
export default {
  data() {
    return {
		show_mask:false,
		scroll_top:0,
		scroll_top_move:true,
		playli: true,
		aboutyi:false,
		proyi:false,
		videoyi:false,
		queryyi:false,
		eliteyi:false,
		contayi:false,
		hovheaitind:0,
		heanavall:'查看全部',
		about: "关于啄木鸟",
		around: "公司环境",
		honor: '公司荣誉',
		news : '新闻中心',
		anticoniden:'防伪鉴别',
		dadownlo:'资料下载',
		maintenance:'维护保养',
		comprob:'常见问题',
		all : "全部",
		society: "社会招聘",
		campus: "校园招聘",
		vidtitleo:'产品介绍',
		vidtitlet:'案例分析',
		vidtitlew:'网络课程',
		heamap:'map',
		message:'留言',
		playri: true,
		pronavnums:9,
		categorylistconts:[],
		lang: session.get("lang"),
		channel_list:[],
		backColor: "blackBack",
		heaproinde:1,
		optionslang: [
			
			{
			valuelang: "EN",
			labellang: "EN",
			},
			{
			valuelang: "CN",
			labellang: "中文",
			},
			
		],
		header_list :[
			{ id: 1, name: "首页"},
			{ id: 3, name: "产品中心"},
			{ id: 4, name: "视频中心"},
			{ id: 5, name: "用户服务"},
			{ id: 2, name: "关于我们"},
			{ id: 5, name: "诚聘精英"},
			{ id: 5, name: "联系我们"},
		],
		value: "",
		valuelang: "",
		categorylist: "",
		list_img:[],
		current_index:0,
		current_clickable:true,//点击后滑动动画执行期间不允许重复点击
		nav_index:-1,//记录当前鼠标触碰到的nav
		nav_text_color:session.get('channel_id')==1?'#e62129':session.get('channel_id')==2?'#1a4698':'#5f5d5d',
		nav_list_bool:false,
		logo_src:'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/ec97fcdb1bb2d7348f61baddbbb2f061.png',
		is_mounted:false,
		nav_title_index1:1,
		nav_title_index3:1,
		nav_title_index4:1,
		nav_title_index5:1,
		nav_title_index6:1,
		nav_product_check:0,
		product_index: 0,
		show_product:false,
		tanimationDelay:0.1,
		nav_title_index:1,
		nav_next_setup:0,
		navRow:1,
		is_parent:false
    };
  },
  created() {
    //请求所有channnel

    this.getIndexData();
    //产品中心
	// let category_list = session.get('category_list')
	// console.log('category_listcategory_list',category_list)
	this.get_channel_category_id_list_all()
    // this.getProductList();

    this.valuelang = session.get("lang")?session.get("lang").toUpperCase():'EN'
    //默认选中品牌
     this.checkChannel();
	//  console.log(session.get('channel_id')==1)
	 this.value = session.get('channel_id')
	//  this.$emit("ChangeEmit")

  },
  watch: {
    valuelang(new_val, old_val) {
		session.set("lang", new_val.toLowerCase());

		this.$store.commit('setLang',new_val.toLowerCase())
      //菜单栏变化
      if (new_val === "CN"){
		//   let base = 'http://localhost:8080/#/'
		//   let base = 'https://www.glzmn.com/dist2222/#/'
		  let base = 'https://www.glzmn.com/#/'
		  let page = sessionStorage.getItem('page')
		  setTimeout(() => {
			  	if(!!page){
					let pageData = JSON.parse(page)
					if(!!pageData.data){
						pageData.data.channel_id = session.get("channel_id")
						let str = this.dataToParama(pageData.data)
						if(pageData.name == 'pcdetails'){

							window.location.replace(base)
							return
						}
						window.location.replace(base+pageData.name+str)
					} else{
						window.location.replace(base+pageData.name+'?channel_id='+ session.get("channel_id"))
					} 
				}else{
					window.location.replace(base)
				}
		  }, 10);
		  return





		this.heanavall="查看全部"
		this.about= "关于啄木鸟",
		this.around= "公司环境",
		this.honor= '公司荣誉',
		this.news = '新闻中心',
		this.anticoniden='防伪鉴别',
		this.dadownlo='资料下载',
		this.maintenance='维护保养',
		this.comprob='常见问题',
		this.all = "全部",
		this.society= "社会招聘",
		this.campus= "校园招聘",
		this.vidtitleo='产品介绍'
		this.vidtitlet='案例分析'
		this.vidtitlew='网络课程'
		this.heamap='地图'
		this.message='留言'
        this.header_list =  [
            { id: 1, name: "首页"},
            { id: 3, name: "产品中心"},
            { id: 4, name: "视频中心"},
            { id: 5, name: "用户服务"},
			{ id: 2, name: "关于我们"},
			{ id: 5, name: "诚聘精英"},
            { id: 5, name: "联系我们"},
          ];
      }else{

		// sessionStorage.removeItem('page')
		  

		  this.heanavall="View All"
		  this.about= "About Woodpecker",
		  this.around= "Company Corner",
		  this.honor= 'Honors',
		  this.news = 'News',
		  
		  this.anticoniden='Anti-Fake Inquiry',
		  this.dadownlo='Download',
		  this.maintenance='Maintenance',
		  this.comprob='FAQ',
		  this.all = "All",
		  this.society= "General Recruitment",
		  this.campus= "Campus Recruitment",
		  this.vidtitleo='Product Introduction'
		  this.vidtitlet='Case Sharing'
		  this.courses='Courses'
		  this.videos='Videos'
		  this.recruit='Join Us'
		  this.vidtitlew='Online'
		  this.heamap='Map'
		  this.message='Online Message'
          this.header_list =  [
			 /* { id: 1, name: "Home Page"},
			  { id: 2, name: "About Us"},
			  { id: 3, name: "Product Center"},
			  { id: 4, name: "Video Center"},
			  { id: 5, name: "User Service "},
			  { id: 5, name: "Recruiting Elite"},
			  { id: 5, name: "Contact Us "}, */
            { id: 1, name: "HOME"},
            { id: 3, name: "PRODUCTS"},
            // { id: 4, name: "VIDEO"},
			  // { id: 6, name: "ACADEMY"},
			  { id: 5, name: "USERS SERVICE"},
          // {id: 6, name: "LEARNING CENTER"},
          {id: 6, name: "ACADEMY"},
			  { id: 2, name: "ABOUT US"},
			  { id: 5, name: "NEWS"},
            { id: 5, name: "CONTACT US"},
          ];
      }
		this.optionslang_change()
      	// this.$emit("ChangeEmit"); //1.向外部触发一个事件
    //   this.getProductList();
		this.get_channel_category_id_list_all()
      	this.getIndexData();
    },
    value(new_val, old_val){
		if (typeof new_val !== 'number' && isNaN(new_val)){
			return;
		}
	  	session.set('channel_id',new_val)
		//   localStorage.setItem('channel_id',new_val)
	  	this.heaproinde=new_val
		let data= {
			mold: "pc", 
			lang:session.get("lang") == '' ? 'en' : session.get("lang"),
			channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
		};
		this.$api.get_channel_index(data).then(() => {
			this.logo_src = 'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/ec97fcdb1bb2d7348f61baddbbb2f061.png'
		});
		var link = document.querySelector("link[rel*='icon']")
	  if(new_val==1){
		  this.backColor="redbacll"
		  link.href = './woodpecker.png'
	  }else if(new_val==2){
		  this.backColor="bluebacll"
		  link.href = './DTE.png'
	  }else if(new_val==3){
		  this.backColor="blackBack"
		  link.href ='./DBA.png'
		  session.set("lang", 'en');
	  }else if(new_val==4){
		  this.backColor="blackBack"
		  link.href = './RTA.png'
		  session.set("lang", 'en');
	  }
    //   session.set("channel_id",new_val);
	  this.nav_text_color=session.get('channel_id')==1?'#e62129':session.get('channel_id')==2?'#1a4698':'#5f5d5d'
		if(this.is_parent){
			return
		}
		this.channel_list_change()
		// this.hometo()
		let channel_id = session.get('channel_id')
		if(this.is_mounted){
			if(channel_id == 3){
				this.valuelang = 'EN'
			}else if(channel_id == 3){
				this.valuelang = 'EN'
			}
			this.checkChannel()
			if(this.$route.path == '/pchome'){
				this.$router.push({ query: {} })
				this.$router.go(0)
			}else{
				this.hometo()
			}
		}
	// 	}
	// }
    //   
		// this.$router.go(0)
    }
  },
  methods: {
    changeLang(value){
      if(value == 'en'){
        let base = 'https://www.glzmn.com/#/'
        let page = sessionStorage.getItem('page')
        setTimeout(() => {
          if(!!page){
            let pageData = JSON.parse(page)
            if(!!pageData.data){
              pageData.data.channel_id = session.get("channel_id")
              let str = this.dataToParama(pageData.data)
              if(pageData.name == 'pcdetails'){

                window.location.replace(base)
                return
              }
              window.location.replace(base+pageData.name+str)
            } else{
              window.location.replace(base+pageData.name+'?channel_id='+ session.get("channel_id"))
            }
          }else{
            window.location.replace(base)
          }
        }, 10);
      }
    },
  	setChannel(channel_id,is_parent){
		this.is_parent = is_parent
  		this.value = channel_id
	},
	  dataToParama(data){
			let arr = Object.keys(data)
			let string = '?'
			for(let i=0;i<arr.length;i++){
				string += arr[i] + '=' +data[arr[i]]
				if(i !== arr.length-1){
					string += '&'
				}
			}
			return string
		},
	  channel_list_change(){
		  this.$emit("ChangeEmit")
		  this.get_channel_category_id_list_all()
	  },
	  optionslang_change(){
		  this.get_channel_category_id_list_all()
 		  this.$emit("ChangeEmit")
	  },
	  get_channel_category_id_list_all(){
		  	let data={
				lang:session.get('lang'),
				channel_id: session.get('channel_id'),
				mold:"pc",
			}
			// this.categorylist=res.data
		 	// this.nav_product_check = res.data[0].id
			// this.categorylistconts=[]
			// // for(let l =0;l<this.pronavnums;l++){
			// // 	this.categorylist.push(this.categorylist[l])
			// // }
			// console.log('this.categorylist',this.categorylist)
			// // this.getProductCateList(res.data[0].id)
			this.$api.get_channel_category_id_list_all(data).then((res) => {
				// console.log('resresresres',res)

				this.categorylist=res.data
				this.nav_product_check = res.data[0].id
				this.getProductCateList(res.data[0].id,this.product_index)
				// this.categorylistconts=[]
				// // for(let l =0;l<this.pronavnums;l++){
				// // 	this.categorylist.push(this.categorylist[l])
				// // }
				// console.log('this.categorylist',this.categorylist)
				// // this.getProductCateList(res.data[0].id)
			});
	  },
	  nav_title_mouse_in(e){
		  e.currentTarget.style.color = this.nav_text_color
	  },
	  nav_title_mouse_out(e){
		  e.currentTarget.style.color = '#333333'
	  },
	  contaenter(){
	    this.contayi=true
	  },
	  contaleave(){
	    // this.contayi=false
	  },
	  eliteenter(){
	    this.eliteyi=true
	  		
	  },
	  eliteleave(){
	    // this.eliteyi=false
	  },
	  queryenter(){
	    this.queryyi=true
	  },
	  queryleave(){
	    // this.queryyi=false
	  },
	  videoenter(){
	    this.videoyi=true
	  		
	  },
	  videoleave(){
	    // this.videoyi=false
	  },
	  proenter(){
	    this.proyi=true
	  },
	  proleave(){
	    // this.proyi=false
	  },
	  aboutenter(){
	    this.aboutyi=true
	  },
	  aboutleave(){
	    // this.aboutyi=false
	  },
	  getHeaderHeight(){
		  return document.getElementsByClassName('nav-center')[0].offsetHeight
	  },
	  navcenter_leave(){//鼠标离开nav
		  this.restNavTitle()
		this.nav_index = -1
		this.show_mask = false
		// console.log('leave_index:'+this.nav_index)
		this.nav_product_check = this.hovheaitind
		this.hovheaitind = 0
		if(this.scroll_top==0){
			document.getElementsByClassName('head_kid_bg_shadow')[0].style.height = 0
		}else{
			// console.log('这里')
			// console.log(document.getElementsByClassName('header-nav')[0].offsetHeight+ 'px')
			document.getElementsByClassName('head_kid_bg_shadow')[0].style.height = document.getElementsByClassName('header-nav')[0].offsetHeight+ 'px'
			// this.scroll_top_move = false
			// document.getElementsByClassName('head_kid_bg_shadow')[0].style.height = document.getElementsByClassName('nav-center')[0].offsetHeight + 'px'
		}
	  },
	  head_nav_mouseenter(index){//鼠标进入nav

		  if(index != 1){
			  this.restNavTitle()
		  }
			this.nav_title_index1 = 1
			this.nav_title_index3 = 1
			this.nav_title_index4 = 1
			this.nav_title_index5 = 1
			this.nav_title_index6 = 1

			this.nav_index = index;
			this.show_mask = true
			this.nav_text_color=session.get('channel_id')==1?'#e62129':session.get('channel_id')==2?'#1a4698':'#5f5d5d'
			if(this.nav_index == 0){
				document.getElementsByClassName('head_kid_bg_shadow')[0].style.height = document.getElementsByClassName('header-nav')[0].offsetHeight+ 'px'
			}else if(this.nav_index == 2){
				if(this.hovheaitind == 0){
					this.getProductCateList(this.nav_product_check)
				}else{
					this.getProductCateList(this.hovheaitind)
				}
			}
			if(index == 1){
				this.getProductCateList(this.hovheaitind)
			}
			// if(this.nav_index !== 2){
			// 	this.nav_product_check = this.hovheaitind
			// 	this.hovheaitind = 0
			// }
	  },
	  restNavTitle(){
		  this.nav_title_index = 1
		  this.nav_next_setup = 0
		  this.nav_list_bool = false
	  },
	  head_kid_bg_listen(){
		  	let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
		  	if(this.$refs.head_kid_bg != undefined){
				if(scrollTop==0){
					document.getElementsByClassName('head_kid_bg_shadow')[0].style.height = this.$refs.head_kid_bg.offsetHeight == 0 ? '0px': this.$refs.head_kid_bg.offsetHeight +70+ 'px'
				}else{
					document.getElementsByClassName('head_kid_bg_shadow')[0].style.height = this.$refs.head_kid_bg.offsetHeight == 0 ? document.getElementsByClassName('header-nav')[0].offsetHeight+'px': this.$refs.head_kid_bg.offsetHeight +70+ 'px'
				}
			}
	  },
	  scroll_listen(){
		  let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
		  this.scrollTop_change(scrollTop)
	  },
	  scrollTop_change(scrollTop,pageName){
		  document.getElementsByClassName('header-nav')[0].style.position = 'absolute'

		  // if(pageName == 'pcquerys' || pageName == 'pcelites'){
			//   document.getElementsByClassName('header-nav')[0].style.position = 'absolute'
		  // }else{
			//   this.scroll_top = scrollTop
			// 	if(this.nav_index==-1){
			// 		if(scrollTop==0){
			// 			// document.getElementsByClassName('head_background')[0].style.background = "none"
			// 			document.getElementsByClassName('head_kid_bg_shadow')[0].style.height = 0
			// 		}else{
			// 			// document.getElementsByClassName('head_background')[0].style.background = "#fff"
			// 			document.getElementsByClassName('head_kid_bg_shadow')[0].style.height = document.getElementsByClassName('header-nav')[0].offsetHeight+ 'px'
			// 		}
			// 	}
		  // }

		  
	  },
		nav_title_click(index){//nav的标题被点击
      console.log('nav_title_click:', index)
			if(index == 0){
				this.hometo()
			}else if(index == 4){
				this.aboutto(1)
			}else if(index == 1){
				this.productto()
			}
      // else if(index ==2){
			// 	this.toCourses()
			// }
      else if(index == 2){
				this.queryto(1)
			}else if(index ==5){
				// this.elitesto()
				this.toNews()
			}else if(index == 6){
				this.contactusto()
			}else if(index == 3){
        window.open('http://121.41.73.197?lang=en')
      }
		},
	  pronavnumser(type='next'){
		  this.nav_list_bool = !this.nav_list_bool
		  let navBox = this.$refs.prodcut_center_nav_box
		  let littleHeight = this.$refs.prodcut_center_little_title[0].offsetHeight
		  let widthTotal = 0
		  this.$refs.prodcut_center_little_title.forEach(item => {
			  widthTotal += item.offsetWidth
		  })
		  this.navRow = Math.ceil(widthTotal / navBox.offsetWidth)
		  let moveTo = 0
		  if(type == 'prve'){
			  this.nav_title_index --
			  moveTo = this.nav_title_index > 1 ? - (littleHeight * (this.nav_title_index-1)) : 0
		  }else {
		  	if(this.navRow > this.nav_title_index){
				moveTo =  - (littleHeight * this.nav_title_index)
				this.nav_title_index ++
			}else {
				moveTo = this.nav_next_setup
			}
		  }
		  navBox.style.marginTop = moveTo + 'px'
		  this.nav_next_setup = moveTo
	    // navBox.style.marginTop =  this.nav_list_bool ? navRow > 1 ? - littleHeight + 'px' : 0  : 0
		//   if(this.pronavnums==this.categorylist.length){
		// 	  this.pronavnums=9
		// 	  this.getProductList()
		//   }else{
		// 	  this.pronavnums=this.categorylist.length
		// 	  this.getProductList()
		//   }
	  },
    getProductCateList(id,index=0){ //根据分类id获取产品
		this.show_product = false
		this.product_index = index
		// if(this.hovheaitind==id){
		// setTimeout(() => {
		// 	let doc = document.getElementsByClassName('product_center_contant')
		// 	if(doc.length==0){
		// 		return
		// 	}
		// 	this.list_img = this.categorylist[this.product_index].list
		// 	if(this.list_img.length>3){
		// 		document.getElementsByClassName('product_center_contant')[0].style.justifyContent = ''
		// 	}else{
		// 		document.getElementsByClassName('product_center_contant')[0].style.justifyContent = 'center'
		// 	}
		// }, 10);
		// return
		// }
		this.hovheaitind=this.categorylist[this.product_index].id
		setTimeout(() => {
			let doc = document.getElementsByClassName('product_center_contant')
			if(doc.length==0){
				return
			}
			doc[0].scrollLeft = 0
			this.list_img = this.categorylist[this.product_index].list
			if(this.list_img.length>3){
				document.getElementsByClassName('product_center_contant')[0].style.justifyContent = ''
			}else{
				document.getElementsByClassName('product_center_contant')[0].style.justifyContent = 'center'
			}
			this.show_product = true
		}, 10);
		// this.list_img = []
		// for(let i=0;i<this.categorylist.length;i++){
		// 	let item = this.categorylist[i]
		// 	if(item.id == id){
		// 		setTimeout(() => {
		// 			let doc = document.getElementsByClassName('product_center_contant')
		// 			if(doc.length==0){
		// 				return
		// 			}
		// 			this.list_img=item.list
		// 			if(item.list.length>3){
		// 				document.getElementsByClassName('product_center_contant')[0].style.justifyContent = ''
		// 			}else{
		// 				document.getElementsByClassName('product_center_contant')[0].style.justifyContent = 'center'
		// 			}
		// 		}, 10);
		// 	}
		// }
		//
		return
		if(this.hovheaitind==id){
			return
		}
		this.hovheaitind=id
		let data={
			lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
			channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
			page:1,
			pageSize:10,
			category_id:id,
			mold:"pc",
		}
		this.list_img = []
		this.$api.get_channel_category_id_list(data).then((res) => {
			this.list_img=res.data
			if(this.list_img.length>3){
				document.getElementsByClassName('product_center_contant')[0].style.justifyContent = ''
			}else{
				document.getElementsByClassName('product_center_contant')[0].style.justifyContent = 'center'
			}
		});
    },
	nav_product_title_click(id){
		this.nav_product_check = id
		this.hovheaitind=id
	},
    getProductList(){
        let data={
          lang:session.get('lang'),
          channel_id: session.get('channel_id'),
        }
        this.$api.get_channel_category_list(data).then((res) => {
			this.categorylist=res.data
		 	this.nav_product_check = res.data[0].id
			this.categorylistconts=[]
			// for(let l =0;l<this.pronavnums;l++){
			// 	this.categorylist.push(this.categorylist[l])
			// }
			// this.getProductCateList(res.data[0].id)
        });
    },
    checkChannel(){
      let _this = this;
      let channel_id =  session.get('channel_id');
	  this.heaproinde=channel_id
		if(channel_id==null){
			channel_id=1
			session.set("channel_id",channel_id);
		}
	  if(channel_id==1){
	  		  this.backColor="redbacll"
			  this.heaproinde=1
			  this.optionslang = [
					
					{
					valuelang: "EN",
					labellang: "EN",
					},
					{
					valuelang: "CN",
					labellang: "中文",
					},
				]
	  }else if(channel_id==2){
	  		  this.backColor="bluebacll"
			  this.heaproinde=2
			  this.optionslang = [
				  {
					valuelang: "EN",
					labellang: "EN",
					},
					{
					valuelang: "CN",
					labellang: "中文",
					},
					
				]
	  }else if(channel_id==3){
	  		  this.backColor="blackBack"
			  this.heaproinde=3
			  session.set("lang",'en');
			  this.optionslang = [
					{
						valuelang: "EN",
						labellang: "EN",
					}
			  ]
	  }else if(channel_id==4){
		 	this.backColor="blackBack"
			this.heaproinde=4
			session.set("lang",'en');
			this.optionslang = [
				{
					valuelang: "EN",
					labellang: "EN",
				}
			]
	  }

      	_this.channel_list.forEach(function(value,index){
		  
        if (value.id == channel_id){
          _this.value = _this.channel_list[index].name;
		  
		  
        }
      });
    },
    getIndexData() {
      this.$api.pcindex({ mold: "pc",lang:session.get("lang") == '' ? 'cn' : session.get("lang") }).then((res) => {
        this.channel_list = res.data;
		// this.logo_src = this.channel_list[this.heaproinde-1].logo
        this.checkChannel();
      });
    },
    hometo() {
      this.$router.push({ path:'/pchome' });
    },
    videoto(e) {
      this.$router.push({ path:'/pcvideos' ,query: {e}});
    },
    queryto(e) {
		// this.$router.push({ path: "/pcquerys",query: {e}});
      switch (e){
        case 3:
          this.$router.push({path: "/pc/compare"});
          break;
        case 4:
          this.$router.push({path: "/pc/download"});
          break;
        default:
          this.$router.push({path: "/pcquerys"});
          break;
      }
	},
    productto() {
      this.$router.push({ path:'/pcproduct' });
    },
    elitesto(e) {
      this.$router.push({ path: "/pcelites",query:{e} });
    },
    contactusto(e) {
		if(e == 3){
			this.$router.push({ path: "/pcelites"});
		}else{
			this.$router.push({ path: "/pccontactus" , query:{e}});
		}
    },
	  toCourses(){
		  this.$router.push({ path: "/pccourses" });
	  },
	  toNewVideo(){
		  this.$router.push({ path: "/pc-academy-videos"});
	  },
	  aboutto(e) {
		  this.$router.push({ path: "/pcabout",query: {e}});
	  },
	  seachto() {
		  this.$router.push({ path: "/pcseachs" });
	  },
	  toNews(){
		  this.$router.push({ path:'/pc-news'});
	  },
    toProduct(e){
		// window.location.href = 'http://www.glzmn.com/#/pcdetails?e='+e
		// window.location.href = 'http://localhost:8080/#/pcdetails?e='+e
		this.$router.push({ path: "/pcdetails",query: {e,type:'pc'}});
    },
    async nextimg() {
      let l = this.list_img.length;
      let scroll = document.getElementsByClassName("product_center_contant")[0];
      let diatance = scroll.scrollWidth - scroll.clientWidth;
	  if(this.current_clickable){
		this.current_clickable = false
		// if (this.current_index == 0) {
		// 	// this.current_index = l - 1;
		// 	scroll.scrollLeft = 0;
		// } else {
			// this.current_index--;
		  let item = this.$refs.product_center_contant_item[0].clientHeight
		  let moveCount = (item * 3) / 10
			for(let i=0;i<moveCount;i++){
				scroll.scrollLeft -= 10;
				await this.await_time()
			}
		// }
		this.current_clickable = true
	  }
	  
    },
    async preimg() {
      let l = this.list_img.length;
      let scroll = document.getElementsByClassName("product_center_contant")[0];
      let diatance = scroll.scrollWidth - scroll.clientWidth;
	  if(this.current_clickable){
		  this.current_clickable = false
		//   console.log(this.current_index)
		//   if (this.current_index > l*1+1) {
		// 		// this.current_index = 0;
		// 		scroll.scrollLeft = diatance;
		// 	} else {
				// this.current_index++;
		  let item = this.$refs.product_center_contant_item[0].clientHeight
		  let moveCount = (item * 3) / 10
			for(let i=0;i<moveCount;i++){
				scroll.scrollLeft += 10;
				await this.await_time()
			}
			// }
			this.current_clickable = true
	  }
    },
	await_time(){
		return new Promise((rev,rej)=>{
			setTimeout(() => {
				rev()
			}, 10);
		})
	},
    enter(index) {
      this.navheader = true;
    },
    playenterli() {
      this.playli = false;
    },

    playenterri() {
      this.playri = false;
    },
    playleaveli() {
      this.playli = true;
    },
    playleaveri() {
      this.playri = true;
    },
    getParams() {
      this.id = this.$route.query.e;
    },
  },
	mounted(){
		this.$nextTick(()=>{
			this.$emit("ChangeEmit")
			this.is_mounted = true
		})
		document.addEventListener('scroll',this.scroll_listen,false)
		 this.$once('hook:beforeDestroy', () => {
			document.removeEventListener('scroll', this.scroll_listen,false)
		})
		this.$nextTick(()=>{
          new ResizeObserver(()=>this.head_kid_bg_listen()).observe(this.$refs.head_kid_bg)
        })
		let channel_id = session.get("channel_id") == '' ? 1 : session.get("channel_id")
		let data= {
			mold: "h5",
			lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
			channel_id: channel_id
		};
		this.$api.get_channel_index(data).then((res) => {
			this.$store.commit('setphLogoImage',res.data.logo_image)
			if(channel_id == 1){
				this.$store.commit('setthemeColor','#e62129')
				this.$store.commit('setBrand','woodpecker')
				this.$store.commit('setthemeArrow',require('../assets/pchomeimg/playne.svg'))
			}else if(channel_id == 2){
				this.$store.commit('setthemeColor','#1a4698')
				this.$store.commit('setBrand','dte')
				this.$store.commit('setthemeArrow',require('../assets/pchomeimg/playne-arrow-dte.svg'))
			}else{
				this.$store.commit('setthemeColor','#000000')
				this.$store.commit('setBrand','dba')
				this.$store.commit('setthemeArrow',require('../assets/pchomeimg/playne-arrow-dba.svg'))
			}
		});
	}
};
</script>

<style>
.header-nav {
	width: 1400px;
	/* height: 79px; */
	display: flex;
	align-items: center;
	padding: 0 260px;
	position: fixed;
	top: 0;
	margin-left: 0;
}
.nav-hover-zone {
	flex: 1;
	min-width: 0;
	position: relative;
	align-self: stretch;
}
.nav-wit {
}
.nav-left {
  min-width: 100px;
  max-height: 50px;
}
.navleftlogo{
	margin-top: 10px;
	flex-shrink: 0;
	width: auto;
	max-width: 411px;
	height: 50px;
	display: flex;
	align-items: center;
	top: 0;
	cursor: pointer;
}
.navleftlogo img {
	height: 50px;
	width: auto;
	max-width: 411px;
	object-fit: contain;
	object-position: left center;
}
.nav-center {
	padding-left: 36px;
	display: flex;
	position: relative;
	color: #fff;
	font-size: 13px;
	font-weight: 400;
	margin-left: 16px;
	padding-right: 130px;
}
.nav-center-item {
	margin-left: 22px;
	height: 79px;
	display: flex;
	align-items: center;
	color:#666;
	border-bottom: 2px solid transparent;
	white-space: nowrap;
	/* transition: all .75s linear; */
}
/* .nav-center-item:hover{
	color: pink;
} */
.navprowh{
	display: flex;
	justify-content: center;
	align-items: center;
	height: 79px;
}
/* .nav-center-item:hover {
  border-bottom: 2px solid yellow;
} */
.redhover:hover{
	border-bottom: 2px solid red;
}
.bluehover:hover{
	border-bottom: 2px solid blue;
}
.blackhover:hover{
	border-bottom: 2px solid black;
}


.nav-center-item:first-child {
  margin-left: 0;
}
.nav-right {
	position: absolute;
	right: 260px;
	flex-shrink: 0;
	min-width: 110px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	color: #fff;
	font-size: 14px;
	font-weight: 400;
}
.nav-right .search {
	width: 20px;
	height: 20px;
	margin-right: 20px;
	cursor: pointer;
	display: flex;
}
.nav-right .search img {
	/* width: 100%;
	height: 100%; */
}
.nav-right .fffhomename {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 20px;
	cursor: pointer;
}
.ffflanguage .el-input--suffix .el-input__inner {
	padding-right: 0px;
	border: none;
}
/* .fffffflanguage .el-input__inner {

}
.ffflanguage .el-select .el-input .el-select__caret {
  font-size: 20px;

} */
.ffflanguage .el-input__inner {
	padding: 0px;
	width: 0px;
	width: 70px;
	background-color: transparent;
}
.ffflanguage .el-select .el-input .el-select__caret {
	font-size: 14px;
	color: #666;
}
/* .language .el-input{
		font-size: 16px;
		font-weight: bold;
		color: #5d5f5f;
		display: flex;
	} */
.nav-right .fffhomename .el-input--suffix .el-input__inner {
	padding-right: 0px;
	border: none;
}
/* .fffhominame .el-input__inner {
  color: #666;
}
.fffhominame .el-select .el-input .el-select__caret {
  font-size: 20px;
  color: #666;
} */
.nav-right .fffhomename .el-input__inner {
	padding: 0px;
	width: 0px;
	width: 120px;
	background-color: transparent;
	color: #666;
}
.nav-right .fffhomename .el-input {
	font-size: 14px;
	font-weight: bold;
	
	display: flex;
	color: #666;
}
 .fffhomename .el-select .el-input .el-select__caret {
	font-size: 20px;
	color: #666;
}
.nav-right .fffhomename .el-icon-arrow-up:before {
}
.nav-right .fffhomename .el-input__prefix,
.nav-right .fffhomename .el-input__suffix {
	position: relative;
	font-size: 14px;
	font-weight: 400;
 
}
.nav-right .fffhomename .el-select {
 	width: 100%;	
}
.nav-right .fffhomename img {
	width: 16px;
	height: 16px;
	margin-left: 4px;
}
.nav-right .ffflanguage {
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
.nav-right .ffflanguage img {
	width: 16px;
	height: 16px;
	margin-left: 6px;
}
.inhover-hea{
	display: flex;
	justify-content: center;
}
.inhoverhea-left{
	display: flex;
	flex-wrap: wrap;
	margin-left: -24px;
	margin-top: 40px;
	width: 1350px;
}
.inhoverhea-right{
	margin-top: 40px;
	width: 20px;
	height: 20px;
}
.inhoverhea-right img{
	width: 100%;
	height: 100%;
}
.hover-content{
	width: 1440px;
	margin: 0 auto;
}
.hoverhea-item{
	margin-left: 24px;
	margin-bottom: 20px;
	color: rgba(0,0,0,.6);
}
.inhover-cent{
	overflow: auto;
	display: flex;
	align-items: center;
	flex-wrap: nowrap;
}
.hovercent-item{
	width: 256px;
	text-align: center;
	color: #333;
	font-size: 14px;
	font-weight: 400;
	margin-bottom: 40px;
	margin-left: 40px;
	margin-top: 40px;
}
.hovercent-item-img{
	width: 256px;
	height: 256px;
	overflow: hidden;
	border-radius: 20px;
	margin-bottom: 20px;
}
.hovercent-item:first-child{
	margin-left: 0;
}
.hovercent-item img{
	width: 256px;
	height: 256px;
	transition: all 1s linear;
}
.hovercent-item img:hover {
	cursor: pointer;
	width: 256px;
	height: 256px;
	transform: scale(1.02,1.02); 
}
.inhover-icon{
	display: flex;
	align-items: center;
	justify-content: center;
}
.netx{
	width: 72px;
	height: 44px;
	cursor: pointer;
	position:relative;
	background: #f7f8fa;
	border-radius: 23px;
}
.netx img{
	width: 18px;
	height: 18px;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	margin:auto;
}
.pre{
	width: 72px;
	height: 44px;
	margin-left: 24px;
	cursor: pointer;
	position:relative;
	background: #f7f8fa;
	border-radius: 23px;
}
.pre img{
	width: 18px;
	height: 18px;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	margin:auto;
}
.bb {
	background-color: red;
	position: fixed;
	top: 0;
	z-index: 99;
}
.hovecentbut{
	display: flex;
	justify-content: center;
	align-items: center;
	margin-left: 25px;
}
.hovecentbut img{
	width: 15px;
	height: 15px;
	margin-left: 10px;
}
.navcc{
	color: #D03E3D;
}
.abouthcont{
	background-color: #fff;
	display: flex;
	position: absolute;
	width: 100%;
	top: 79px;
	left: 0;
	/* height: 100px; */
	font-size: 14px;
	font-weight: 400;
	color: #5d5f5f;
	align-items: center;
	justify-content: center;
	transition: height 0.5s;
}
.aboutitem{
	color: rgba(0,0,0,.6);
	/* transform: translateY(-30%);
	opacity: 0; */
	margin-left: 100px;
	/* margin-right: 70px; */
}
.aboutitem:first-child{
	margin-left: -200px;
}
/* .aboutitem:hover{
	color: #D03E3D;
} */
.queryhcont{
	display: flex;
	position: absolute;
	width: 100%;
	background: #FFFFFF;
	top: 79px;
	left: 0;
	font-size: 14px;
	font-weight: 400;
	color: #5d5f5f;
	height: 100px;
	align-items: center;
	justify-content: center;
}
.queryitem{
	margin-left: 100px;
	color: rgba(0,0,0,.6);
}
.queryitem:first-child{
	margin-left: -200px;
}
.queryitem:hover{
	color: #D03E3D;
}
.eliteshcont{
	display: flex;
	position: absolute;
	width: 100%;
	background: #FFFFFF;
	top: 79px;
	left: 0;
	font-size: 14px;
	font-weight: 400;
	color: #5d5f5f;
	height: 100px;
	align-items: center;
	justify-content: center;
}
.elitesitem{
	margin-left: 100px;
	color: rgba(0,0,0,.6);
}
.elitesitem:first-child{
	margin-left: -200px;
}
.elitesitem:hover{
	color: #D03E3D;
	
}
.contacthcont{
	display: flex;
	position: absolute;
	width: 100%;
	background: #FFFFFF;
	top: 79px;
	left: 0;
	font-size: 14px;
	font-weight: 400;
	color: #5d5f5f;
	height: 100px;
	align-items: center;
	justify-content: center;
}
.contactitem{
	margin-left: 100px;
	color: rgba(0,0,0,.6);
}
.contactitem:first-child{
	margin-left: -200px;
}
.contactitem:hover{
	color: #D03E3D;
}
/* .navvideo:hover .videouhover{
	display: block;
}
.videouhover{
	display: none;
} */
.videohcont{
	display: flex;
	position: absolute;
	width: 100% !important;
	background: #FFFFFF;
	top: 79px;
	left: 0;
	font-size: 14px;
	font-weight: 400;
	color: #5d5f5f;
	/* height: 100px; */
	align-items: center;
	justify-content: center;
}
.videoitem{
	margin-left: 100px;
	color: rgba(0,0,0,.6);
}
.videoitem:first-child{
	margin-left: -200px;
}
.videoitem:hover{
	color: #D03E3D;
}
.abouanmin{
	-webkit-animation-name: "drop-down"; /*动画名称，需要跟@keyframes定义的名称一致*/
	-webkit-animation-duration: 2s;/*动画持续的时间长*/
	-webkit-animation-iteration-count: 1;/*动画循环播放的次数为1 infinite为无限次*/
	color: #0000FF;
}
.aboutaniter{
	transform: translateY(-100%) !important;
	opacity: 1 !important;
	transition: all 0.5s ease;
	/* transition-delay:0.5s; */
}
.aboutani{
	transform: translateY(0%);
	opacity: 0;
}

.aboutaniterzz{
	height: 0px;
	position: absolute;
	top: 79px !important;
	/* background: red !important; */
	
}
/* .nav-center-item:hover .aboutaniterzz{
	height: 100px;
} */
.aboutanizz{
	/* position: absolute;
	top: -488px; */
	/* position: absolute;
	width: 100% !important;
	background: red;
	top: -179px; */
	
	background: #FFF;
}
.videouhover{
	
	
	/* position: absolute; */
	/* top: -488px; */
}
.videohcont{
	display: flex;
	position: absolute;
	width: 100% !important;
	background: #FFF;
	top: -179px;
	left: 0;
	font-size: 14px;
	font-weight: 400;
	color: #5d5f5f;
	/* height: 100px; */
	align-items: center;
	justify-content: center;
}
.proaniter{
	transform: translateY(0%) !important;
	opacity: 1 !important;
	transition: all 1s ease;
}
.proani{
	transform: translateY(10%);
	opacity: 0;
}
.proaniterzz{
	
	position: absolute;
	display: block !important;
	top: 79px !important;
	background: #FFFFFF;
	/* background: red !important; */
}
.proanizz{
	/* position: absolute;
	top: -488px; */
	/* position: absolute;
	width: 100% !important;
	background: red;
	top: -179px; */
	
	background: #FFF;
}
.index-hover{
	display: block !important;
	position: absolute;
	width: 100%;
	background: #FFFFFF;
	top: -889px;
	left: 0;
	font-size: 14px;
	font-weight: 400;
	color: #5d5f5f;
	padding-bottom: 40px;
	box-sizing: border-box;
	translate: height 0.5s;
}
/* .abouthcont{
	background-color: #fff;
	display: flex;
	position: absolute;
	width: 100%;
	top: -179px;
	left: 0;
	height: 0;
	font-size: 14px;
	font-weight: 400;
	color: #5d5f5f;
	align-items: center;
	justify-content: center;
} */
.videoaniter{
	transform: translateY(0%) !important;
	opacity: 1 !important;
	transition: all 1s ease;
}
.videoani{
	transform: translateY(-100%);
	opacity: 0;
}
.videoaniterzz{
	height: 100px;
	position: absolute;
	top: 79px !important;
}
.videoanizz{
	background: #FFF;
}
.queryhcont{
	display: flex;
	position: absolute;
	width: 100%;
	background: #FFFFFF;
	top: -179px;
	left: 0;
	font-size: 14px;
	font-weight: 400;
	color: #5d5f5f;
	height: 100px;
	align-items: center;
	justify-content: center;
}
.queryaniter{
	transform: translateY(0%) !important;
	opacity: 1 !important;
	transition: all 1s ease;
}
.queryani{
	transform: translateY(-100%);
	opacity: 0;
}
.queryaniterzz{
	height: 100px;
	position: absolute;
	top: 79px !important;
}
.queryanizz{
	background: #FFF;
}
.eliteshcont{
	display: flex;
	position: absolute;
	width: 100%;
	background: #FFFFFF;
	top: -179px;
	left: 0;
	font-size: 14px;
	font-weight: 400;
	color: #5d5f5f;
	height: 100px;
	align-items: center;
	justify-content: center;
}
.eliteaniter{
	transform: translateY(0%) !important;
	opacity: 1 !important;
	transition: all 1s ease;
}
.eliteani{
	transform: translateY(-100%);
	opacity: 0;
}
.eliteaniterzz{
	height: 100px;
	position: absolute;
	top: 79px !important;
}
.eliteanizz{
	background: #FFF;
}
.contacthcont{
	display: flex;
	position: absolute;
	width: 100%;
	background: #FFFFFF;
	top: -179px;
	left: 0;
	font-size: 14px;
	font-weight: 400;
	color: #5d5f5f;
	height: 100px;
	align-items: center;
	justify-content: center;
}
.contaaniter{
	transform: translateY(0%) !important;
	opacity: 1 !important;
	transition: all 1s ease;
}
.contaani{
	transform: translateY(-100%);
	opacity: 0;
}
.contaaniterzz{
	height: 100px;
	position: absolute;
	top: 79px !important;
}
.contaanizz{
	background: #FFF;
}
.redbacll:hover{
	color: #D03E3D;
}
.bluebacll:hover{
	color: #0000FF;
}
.blackBack:hover{
	color: #000000;
}
.pronavred{
	color: #D03E3D;
}
.pronavblue{
	color: #0000FF;
}
.pronavblack{
	color: #000000;
}
.text_blue{
	color:#666
}
/* .text_blue:hover{
	color: #D03E3D;
} */
</style>


<style scoped>
.head_kid_bg{
	display: flex;
	position: fixed;
	width: 1920px;
	max-width: 100vw;
	top: 79px;
	left: 50%;
	transform: translateX(-50%);
	font-size: 14px;
	/* background: #FFFFFF; */
	font-weight: 400;
	color: #5d5f5f;
	justify-content: center;
	z-index: -3;
}
.head_kid_bg_shadow{
	width: 1920px;
	max-width: 100vw;
	top: 0;
	position: fixed;
	left: 50%;
	transform: translateX(-50%);
	height: 0;
	background: #FFF;
	transition: height 0.3s;
	z-index: -4;
}
.nav_text_tag{
	display: inline-block;
	margin-right: 100px;
	font-size: 14px;
	font-weight: 400;
	margin: 40px 100px 46px 0;
	color: #5d5f5f;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	opacity: 0;
	transform: translateY(100%);
	animation: nav_text_tag_move 0.3s forwards ease;
	/* animation-delay: 0.2s; */
}

@keyframes nav_text_tag_move{
	
	0%{}
	100% {
		transform: translateY(0%);
		opacity: 1;
	}
	
}
.prodcut_center {
	position: relative;
}
.prodcut_center_nav{
	width: 1350px;
	padding-right: 20px;
	height: 27px;
	display: flex;
	flex-wrap: wrap;
	/* background: red; */
	text-align: start;
	position: relative;
	margin-top: 40px;
	overflow: hidden;
	justify-content: center
}
.prodcut_center_nav_box {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 1330px;
	flex-wrap: wrap;
	transition: all .5s cubic-bezier(.56,-0.37,.78,1.66) 0s;
}
.prodcut_center_little_title{
	white-space: nowrap;
	display: block;
	padding: 0 12px 20px 12px;
	color: rgba(0,0,0,.6);
	opacity: 0;
	transform: translateY(100%);
	animation: nav_text_tag_move 0.3s forwards ease;
	/* animation-delay: 0.3s; */
}
.hoverxia{
	position: absolute;
	top: 40px;
	right: 0;
	opacity: 0;
	transform: translateY(100%);
	animation: nav_text_tag_move 0.3s forwards ease;
	width: 16px;
	height: 32px;
	z-index: 10;
	/* animation-delay: 0.3s; */
}
.hoverxia img{
	width: 16px;
	height: 16px;
	display: block;
	cursor: pointer;
}
/*.prodcut_center_little_title:hover{*/
/*	color: #D03E3D;*/
/*}*/
.product_center_contant{
	width: 1350px;
	height: 356px;
	overflow-y: hidden;
	overflow-x: hidden;
	display: flex;
	align-items: center;
	/* flex-wrap: nowrap; */
	flex-direction: row;/*这里可以不写，flex布局默认方向横向即row*/
  padding-right: 20px;
}
.product_center_contant_item{
	width: 256px;
	text-align: center;
	color: #5d5f5f;
	font-size: 14px;
	font-weight: 400;
	/*margin-bottom: 40px;*/
	/*margin-left: 40px;*/
	/*margin-top: 40px;*/
	padding: 40px 0 40px 40px;
	opacity: 0;
	transform: translateY(10%);

}
.product_center_contant_item_animate {
	/*animation: nav_text_tag_move .5s forwards ease;*/
	animation-name:nav_text_tag_move;
	animation-duration:.5s;
	animation-timing-function:ease;
	animation-fill-mode:forwards;

}

.product_center_contant_item_img{
	width: 256px;
	height: 256px;
	//overflow: hidden;
	//border-radius: 22px;
	//-webkit-border-radius:22px;
	//-ms-border-radius:22px;
	//-o-border-radius:22px;
	//-moz-border-radius:22px;
	transform: rotate(0deg);
	margin-bottom: 20px;
}


.inhover-icon{
	margin-bottom: 80px ;
	opacity: 0;
	transform: translateY(100%);
	animation: nav_text_tag_move 0.3s forwards ease;
	/* animation-delay: 0.3s; */
}
.hovecentbut{
	cursor: pointer;
}
.head_background{
	 background: #FFFFFF;
	position: fixed;
	top: 0; 
	z-index: 99;
	
}
.product_center_contant_item_img img{
	width: 100%;
	height: 100%;
	cursor: pointer;
	transition: all 1s ;
}

.product_center_contant_item_img img:hover{
	transform: scale(1.1,1.1)
}
.header_mask{
	width: 100%;
	height: 100vh;
	background: #000000;
	opacity: .2;
	position: fixed;
	left: 0;
	top: 0;
	z-index: -10;
}
.red_hover:hover{
	color: red;
}
.blue_hover:hover{
	color: blue;
}
.black_hover:hover{
	color:black
}
.hoverRTA:hover , .hoverDBA:hover {
	color: #000!important;
}
.hoverWOODPECKER , .hoverDTE , .hoverRTA , .hoverDBA {
	color:#5f5d5d!important;
}
.hoverWOODPECKER:hover {
	color: #e62129!important;
}
.hoverDTE:hover {
	color: #1a4698!important;
}
</style>